import { CenterItem, RowAlignedItems } from '@components/LinearLayout';
import {
  LANGUAGE_SWITCHER_MODE,
  LANGUAGE_SWITCHER_MODE_TYPE,
} from '@utils/constants';

import { H4 } from '@components/Typography';
import { styled } from 'styled-components';

export const LanguageSwitcherRoot = styled(RowAlignedItems)<{
  mode: (typeof LANGUAGE_SWITCHER_MODE_TYPE)[number];
}>`
  background-color: ${props =>
    props.mode === LANGUAGE_SWITCHER_MODE.LIGHT
      ? props.theme.color.whiteOp10
      : props.theme.color.grey3};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  gap: 0.6rem;
  padding: ${props =>
    props.mode === LANGUAGE_SWITCHER_MODE.LIGHT
      ? '0.5rem 1.1rem'
      : '0.7rem 1.5rem'};

  &:hover {
    cursor: pointer;
  }
`;

export const Item = styled(H4)<{ $isHovered: boolean; $fontWeight?: string }>`
  color: ${({ theme, $isHovered }) =>
    $isHovered ? theme.color.mobilityBlue : theme.color.shadeGrey1};
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ $fontWeight, theme }) =>
    $fontWeight || theme.fontWeight.weight400};
`;

export const Divider = styled(CenterItem)`
  width: 0.2rem;
  height: 2.3rem;
  background-color: ${({ theme }) => theme.color.shadeGrey1};
`;
